import { render } from "./DiscountModal.vue?vue&type=template&id=32c8c023&scoped=true"
import script from "./DiscountModal.vue?vue&type=script&lang=js"
export * from "./DiscountModal.vue?vue&type=script&lang=js"

import "./DiscountModal.vue?vue&type=style&index=0&id=32c8c023&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c8c023"]])

export default __exports__